$(window).on("load", () => {
  setTimeout(function () {
    $(".notification").remove();
  }, 1700);

  setTimeout(function () {
    $(".alert").remove();
  }, 1700);
});
